<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Название:</label>
              <input
                @keyup.enter="apply"
                class="form-control"
                v-model="currFilters.name"
              />
            </div>
          </div>
        </div>
        <div
          v-if="dictName === 'state' || dictName === 'region' || isImportable"
          class="row"
        >
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Код:</label>
              <input
                @keyup.enter="apply"
                class="form-control"
                v-model="currFilters.code"
              />
            </div>
          </div>
        </div>
        <div v-if="dictName === 'organizationsubtype'" class="row">
          <div class="col-md-12">
            <div class="form-group select2">
              <label class="control-label">Тип организации:</label>
              <Select2
                @keyup.enter="apply"
                :options="organizationTypeList"
                :settings="select2Settings"
                v-model="currFilters.referenceId"
              />
            </div>
          </div>
        </div>
        <div
          v-if="dictName === 'organizationtype' || dictName === 'servicetype'"
          class="row"
        >
          <div class="col-md-12">
            <div class="form-group select2">
              <label class="control-label">Вид деятельности:</label>
              <Select2
                @keyup.enter="apply"
                :options="kindActivityList"
                :settings="select2Settings"
                v-model="currFilters.referenceId"
              />
            </div>
          </div>
        </div>
        <div v-if="dictName === 'region'" class="row">
          <div class="col-md-12">
            <div class="form-group select2">
              <label class="control-label">Государство:</label>
              <Select2
                @keyup.enter="apply"
                :options="stateList"
                :settings="select2Settings"
                v-model="currFilters.referenceId"
              />
            </div>
          </div>
        </div>
        <div v-if="dictName === 'district'" class="row">
          <div class="col-md-12">
            <div class="form-group select2">
              <label class="control-label">Субъект государства:</label>
              <Select2
                @keyup.enter="apply"
                :options="regionList"
                :settings="select2Settings"
                v-model="currFilters.referenceId"
              />
            </div>
          </div>
        </div>
        <div
          v-if="
            dictName === 'educationalprogram' ||
            dictName === 'classkind' ||
            dictName === 'classlevel'
          "
          class="row"
        >
          <div class="col-md-12">
            <div class="form-group select2">
              <label class="control-label">Уровень образования:</label>
              <Select2
                @keyup.enter="apply"
                :options="educationLevelList"
                :settings="select2Settings"
                v-model="currFilters.referenceId"
              />
            </div>
          </div>
        </div>
        <div v-if="dictName === 'educationform'" class="row">
          <div class="col-md-12">
            <div class="form-group select2">
              <label class="control-label">Категория обучения:</label>
              <Select2
                @keyup.enter="apply"
                :options="educationCategoryList"
                :settings="select2Settings"
                v-model="currFilters.referenceId"
              />
            </div>
          </div>
        </div>
        <div
          v-if="
            dictName === 'recomspeechtherapy' ||
            dictName === 'recompedagogical' ||
            dictName === 'recompsychological'
          "
          class="row"
        >
          <div class="col-md-12">
            <div class="form-group select2">
              <label class="control-label">Образовательная программа:</label>
              <Select2
                @keyup.enter="apply"
                :options="educationalProgramList"
                :settings="select2Settings"
                v-model="currFilters.referenceId"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex">
        <button-component class="btn btn-primary col-6" v-on:click="apply">
          Применить
        </button-component>
        <button-component
          kind="secondary"
          class="btn btn-default col-6"
          v-on:click="reset"
        >
          Сбросить
        </button-component>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../../../common/constants";
import Utils from "../../../common/utils";
import ButtonComponent from "@/common/ui/ButtonComponent";

export default {
  name: "DictionaryItemsFilter",
  components: { ButtonComponent },
  props: {
    dictName: String,
    filters: Object,
    isImportable: Boolean,
  },
  data() {
    return {
      currFilters: this.filters,
      organizationTypeList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      kindActivityList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      stateList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      regionList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      educationLevelList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      educationCategoryList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      educationalProgramList: [
        { id: 0, text: Constants.emptySelectOptionText, selected: true },
      ],
      select2Settings: Constants.select2Settings,
    };
  },
  created() {
    Utils.loadSelectOptions("kindActivity", this.kindActivityList);
    Utils.loadSelectOptions("organizationType", this.organizationTypeList);
    Utils.loadSelectOptions("state", this.stateList);
    Utils.loadSelectOptions("region", this.regionList);
    Utils.loadSelectOptions("educationlevel", this.educationLevelList);
    Utils.loadSelectOptions("educationcategory", this.educationCategoryList);
    Utils.loadSelectOptions("educationalprogram", this.educationalProgramList);
  },
  methods: {
    apply() {
      const filters = Object.assign({}, this.currFilters);
      this.$emit("apply", filters);
    },
    reset() {
      this.currFilters = {
        name: "",
        code: "",
        referenceId: 0,
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit("reset", filters);
    },
  },
};
</script>
<style scoped lang="scss">
.select2::v-deep {
  .select2-container {
    width: 100% !important;
    max-width: 100% !important;
  }

  .select2-container--default .select2-selection--single {
    height: calc(2.25rem + 2px) !important;
  }

  .select2-container--default
    .select2-selection--single
    .select2-selection__arrow {
    top: 7px !important;
  }
}
.form-group.required .control-label:after {
  content: "*";
  color: red;
}

.card-footer {
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
</style>
